"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFinleyVanProduct = exports.isFinleyVanLoanAcct = exports.isFinleyVanList = exports.isFinleyVanDepAcct = exports.isFinleyVanCustAcctRel = exports.isFinleyVanCust = exports.isFinleyVanCmmt = exports.isFinleyPsPlusSecMaster = exports.isFinleyPsPlusSecDetail = exports.isFinleyPsPlusPortfolio = exports.isFinleyPsPlusAccount = exports.isFinleyLoanCustRel = exports.isFinleyCuoMaint = exports.isFinleyCuoLoan = exports.isFinleyCuoDeposit = exports.isFinleyCuoCollat = exports.isFinleyCollatCustRel = exports.isValleyBankPortfolioReceivableResponseTape = exports.hasValleyBankRequiredBaseFields = exports.isValleyBankPortfolioReceivableResponseTapeMetadataStatusInProgress = exports.isValleyBankPortfolioReceivableResponseTapeMetadataStatusFailure = exports.isValleyBankPortfolioReceivableResponseTapeMetadataStatusSuccess = exports.isValleyBankWorklease = exports.isValleyBankReceivableResponseTapeWorklease = exports.isValleyBankPipelineStatusMetadata = exports.isValleyBankArrangementGroup = exports.isValleyBankPortfolioReceivableResponseTapeStats = exports.isValleyBankLoanAccountWithCollateralAndStats = exports.isFinleyValleyBankResponseTapeRow = exports.isValleyBankLoanAccountWithCollateralStats = exports.isValleyBankCustomerWithRelationships = exports.isValleyBankDerivativePath = exports.isValleyBankBloombergMutualFund = exports.isValleyBankCuoMaint = exports.isValleyBankCuoLoan = exports.isValleyBankVanLoanAcct = exports.isValleyBankVanCmmt = exports.isValleyBankVanProduct = exports.isValleyBankVanList = exports.isValleyBankCuoDepositSchema = exports.isValleyBankCollatCustRel = exports.isValleyBankCuoCollat = exports.isValleyBankLoanCustRel = exports.isValleyBankPsPlusSecMaster = exports.isValleyBankPsPlusSecDetail = exports.isValleyBankPsPlusAccount = exports.isValleyBankPsPlusPortfolio = exports.isValleyBankVanCustAcctRel = exports.isValleyBankVanDepAcct = exports.isValleyBankVanCust = void 0;
exports.isValleyBankRequiredBaseFields = exports.isValleyBankAccountCollateralAccountType = exports.isValleyBankHistoricalLoanAccountToPinnedComment = exports.isValleyBankCollateralToLoanAccountMapping = exports.isValleyBankLoanAccountStats = exports.isValleyBankCollateralAccountStats = exports.isFinleyDerivativePath = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const finley_types_1 = require("@finley-technologies/finley-types");
const consts_1 = require("../consts");
const schema = __importStar(require("../schema"));
const types_1 = require("../types");
const isValleyBankVanCust = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanCustSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanCust = isValleyBankVanCust;
const isValleyBankVanDepAcct = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanDepAcctSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanDepAcct = isValleyBankVanDepAcct;
const isValleyBankVanCustAcctRel = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanCustAcctRelSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanCustAcctRel = isValleyBankVanCustAcctRel;
const isValleyBankPsPlusPortfolio = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankPsPlusPortfolioSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankPsPlusPortfolio = isValleyBankPsPlusPortfolio;
const isValleyBankPsPlusAccount = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankPsPlusAccountSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankPsPlusAccount = isValleyBankPsPlusAccount;
const isValleyBankPsPlusSecDetail = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankPsPlusSecDetailSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankPsPlusSecDetail = isValleyBankPsPlusSecDetail;
const isValleyBankPsPlusSecMaster = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankPsPlusSecMasterSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankPsPlusSecMaster = isValleyBankPsPlusSecMaster;
const isValleyBankLoanCustRel = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankLoanCustRelSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankLoanCustRel = isValleyBankLoanCustRel;
const isValleyBankCuoCollat = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankCuoCollatSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankCuoCollat = isValleyBankCuoCollat;
const isValleyBankCollatCustRel = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankCollatCustRelSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankCollatCustRel = isValleyBankCollatCustRel;
const isValleyBankCuoDepositSchema = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankCuoDepositSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankCuoDepositSchema = isValleyBankCuoDepositSchema;
const isValleyBankVanList = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanListSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanList = isValleyBankVanList;
const isValleyBankVanProduct = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanProductSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanProduct = isValleyBankVanProduct;
const isValleyBankVanCmmt = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanCmmtSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanCmmt = isValleyBankVanCmmt;
const isValleyBankVanLoanAcct = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankVanLoanAcctSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankVanLoanAcct = isValleyBankVanLoanAcct;
const isValleyBankCuoLoan = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankCuoLoanSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankCuoLoan = isValleyBankCuoLoan;
const isValleyBankCuoMaint = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankCuoMaintSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankCuoMaint = isValleyBankCuoMaint;
const isValleyBankBloombergMutualFund = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankBloombergMutualFundSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankBloombergMutualFund = isValleyBankBloombergMutualFund;
const isValleyBankDerivativePath = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankDerivativePathSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankDerivativePath = isValleyBankDerivativePath;
// ################################
// #
// # EXPOSED MAPPER TYPEGUARDS FOR GQL + FE
// #
// ################################
const isValleyBankCustomerWithRelationships = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankCustomerWithRelationshipsSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankCustomerWithRelationships = isValleyBankCustomerWithRelationships;
const isValleyBankLoanAccountWithCollateralStats = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankLoanAccountWithCollateralStatsSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankLoanAccountWithCollateralStats = isValleyBankLoanAccountWithCollateralStats;
const isFinleyValleyBankResponseTapeRow = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.FinleyValleyBankResponseTapeRowSchema, { nestedErrors: true });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isFinleyValleyBankResponseTapeRow = isFinleyValleyBankResponseTapeRow;
const isValleyBankLoanAccountWithCollateralAndStats = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankLoanAccountWithCollateralAndStatsSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankLoanAccountWithCollateralAndStats = isValleyBankLoanAccountWithCollateralAndStats;
const isValleyBankPortfolioReceivableResponseTapeStats = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankPortfolioReceivableResponseTapeStatsSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankPortfolioReceivableResponseTapeStats = isValleyBankPortfolioReceivableResponseTapeStats;
const isValleyBankArrangementGroup = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankArrangementGroupSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankArrangementGroup = isValleyBankArrangementGroup;
const isValleyBankPipelineStatusMetadata = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankPipelineStatusMetadataSchema, {
        nestedErrors: true,
    });
    if (result.errors.length) {
        throw new Error(`${result.errors.map((error) => error.stack)}`);
    }
    return result.valid;
};
exports.isValleyBankPipelineStatusMetadata = isValleyBankPipelineStatusMetadata;
// ################################
// #
// # MISC TYPEGUARDS
// #
// ################################
const isValleyBankReceivableResponseTapeWorklease = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankReceivableResponseTapeWorkleaseSchema, {
        nestedErrors: true,
    });
    return result.valid;
};
exports.isValleyBankReceivableResponseTapeWorklease = isValleyBankReceivableResponseTapeWorklease;
const isValleyBankWorklease = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankReceivableWorkleaseSchema, {
        nestedErrors: true,
    });
    return result.valid;
};
exports.isValleyBankWorklease = isValleyBankWorklease;
const isValleyBankPortfolioReceivableResponseTapeMetadataStatusSuccess = (test) => {
    return test === consts_1.VALLEY_BANK_PIPELINE_SUCCESS_STATUS;
};
exports.isValleyBankPortfolioReceivableResponseTapeMetadataStatusSuccess = isValleyBankPortfolioReceivableResponseTapeMetadataStatusSuccess;
const isValleyBankPortfolioReceivableResponseTapeMetadataStatusFailure = (test) => {
    return test === consts_1.VALLEY_BANK_PIPELINE_FAILURE_STATUS;
};
exports.isValleyBankPortfolioReceivableResponseTapeMetadataStatusFailure = isValleyBankPortfolioReceivableResponseTapeMetadataStatusFailure;
const isValleyBankPortfolioReceivableResponseTapeMetadataStatusInProgress = (test) => {
    return test === consts_1.VALLEY_BANK_PIPELINE_IN_PROGRESS_STATUS;
};
exports.isValleyBankPortfolioReceivableResponseTapeMetadataStatusInProgress = isValleyBankPortfolioReceivableResponseTapeMetadataStatusInProgress;
const hasValleyBankRequiredBaseFields = (obj) => {
    const result = jsonschema_1.default.validate(obj, schema.ValleyBankRequiredBaseFieldsSchema, {
        nestedErrors: true,
    });
    return result.valid;
};
exports.hasValleyBankRequiredBaseFields = hasValleyBankRequiredBaseFields;
exports.isValleyBankPortfolioReceivableResponseTape = finley_types_1.typeguards.typeguardFunctionWrapper(schema.ValleyBankPortfolioReceivableResponseTapeSchema);
exports.isFinleyCollatCustRel = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyCollatCustRelSchema);
exports.isFinleyCuoCollat = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyCuoCollatSchema);
exports.isFinleyCuoDeposit = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyCuoDepositSchema);
exports.isFinleyCuoLoan = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyCuoLoanSchema);
exports.isFinleyCuoMaint = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyCuoMaintSchema);
exports.isFinleyLoanCustRel = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyLoanCustRelSchema);
exports.isFinleyPsPlusAccount = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyPsPlusAccountSchema);
exports.isFinleyPsPlusPortfolio = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyPsPlusPortfolioSchema);
exports.isFinleyPsPlusSecDetail = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyPsPlusSecDetailSchema);
exports.isFinleyPsPlusSecMaster = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyPsPlusSecMasterSchema);
exports.isFinleyVanCmmt = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanCmmtSchema);
exports.isFinleyVanCust = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanCustSchema);
exports.isFinleyVanCustAcctRel = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanCustAcctRelSchema);
exports.isFinleyVanDepAcct = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanDepAcctSchema);
exports.isFinleyVanList = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanListSchema);
exports.isFinleyVanLoanAcct = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanLoanAcctSchema);
exports.isFinleyVanProduct = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyVanProductSchema);
exports.isFinleyDerivativePath = finley_types_1.typeguards.typeguardFunctionWrapper(schema.FinleyDerivativePathSchema);
exports.isValleyBankCollateralAccountStats = finley_types_1.typeguards.typeguardFunctionWrapper(schema.ValleyBankCollateralAccountStatsSchema);
exports.isValleyBankLoanAccountStats = finley_types_1.typeguards.typeguardFunctionWrapper(schema.ValleyBankLoanAccountStatsSchema);
exports.isValleyBankCollateralToLoanAccountMapping = finley_types_1.typeguards.typeguardFunctionWrapper(schema.ValleyBankCollateralToLoanAccountMappingSchema);
exports.isValleyBankHistoricalLoanAccountToPinnedComment = finley_types_1.typeguards.typeguardFunctionWrapper(schema.ValleyBankHistoricalLoanAccountToPinnedCommentSchema);
exports.isValleyBankAccountCollateralAccountType = finley_types_1.typeguards.typeguardFunctionWrapper(schema.ValleyBankAccountCollateralTypeSchema);
const isValleyBankRequiredBaseFields = (test) => {
    return types_1.valleyBankRequiredBaseFieldsIterable.some((field) => field === test);
};
exports.isValleyBankRequiredBaseFields = isValleyBankRequiredBaseFields;
//# sourceMappingURL=index.js.map